import * as React from "react";
import { forwardRef } from "react";
const SvgRightTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1.62103C1 0.945648 1.82277 0.61438 2.29076 1.10134L14.7688 14.085C15.2268 14.5616 14.889 15.3547 14.228 15.3547H1.75C1.33579 15.3547 1 15.0189 1 14.6047V1.62103Z", stroke: "#2B2B35", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgRightTriangle);
export { ForwardRef as ReactComponent };
